<div class="content-box">
  <div class="d-flex justify-content-end">
    <app-todos-servicos-usuario-logado [mostrarAcessoArea]="false"></app-todos-servicos-usuario-logado>
  </div>
  
  <div class="area-cidadao">
    <nav class="area-cidadao-menu" aria-label="Área do cidadão">
      <ul class="area-cidadao-menu-lista">
        @for (secao of secoes; track secao.id) {
        <li>
          <a class="area-cidadao-menu-item" routerLink="/area-cidadao" [queryParams]="{ aba: secao.id }"
            [class.area-cidadao-menu-item-ativo]="secao.id === secaoAtiva()"
            [attr.aria-current]="secao.id === secaoAtiva() ? 'page' : null">
            <i-lucide [name]="secao.icone" size="18" aria-hidden="true"></i-lucide>
            {{ secao.titulo }}
          </a>
        </li>
        }
      </ul>
    </nav>

    <div class="area-cidadao-conteudo">
      <app-breadcrumb [pagina]="tituloSecao()"
        [intermediarios]="[{ titulo: 'Área do cidadão', link: 'area-cidadao' }]"></app-breadcrumb>

      @switch (secaoAtiva()) {
      @case ('agendamento') {
      <app-agendamento></app-agendamento>
      }

      @case ('meus-agendamentos') {
      <app-meus-agendamentos></app-meus-agendamentos>
      }

      @case ('solicitacoes') {
      <app-minhas-solicitacoes></app-minhas-solicitacoes>
      }

      @case ('dados') {
      <app-dados-pessoais></app-dados-pessoais>
      }

      @case ('favoritos') {
      <app-servicos-favoritos></app-servicos-favoritos>
      }
      }
    </div>
  </div>
</div>